/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSearchTranslationPreferenceRequest
 */
export interface UpdateSearchTranslationPreferenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSearchTranslationPreferenceRequest
     */
    preference: UpdateSearchTranslationPreferenceRequestPreferenceEnum;
}


/**
 * @export
 */
export const UpdateSearchTranslationPreferenceRequestPreferenceEnum = {
    Auto: 'AUTO',
    Manual: 'MANUAL'
} as const;
export type UpdateSearchTranslationPreferenceRequestPreferenceEnum = typeof UpdateSearchTranslationPreferenceRequestPreferenceEnum[keyof typeof UpdateSearchTranslationPreferenceRequestPreferenceEnum];


/**
 * Check if a given object implements the UpdateSearchTranslationPreferenceRequest interface.
 */
export function instanceOfUpdateSearchTranslationPreferenceRequest(value: object): value is UpdateSearchTranslationPreferenceRequest {
    if (!('preference' in value) || value['preference'] === undefined) return false;
    return true;
}

export function UpdateSearchTranslationPreferenceRequestFromJSON(json: any): UpdateSearchTranslationPreferenceRequest {
    return UpdateSearchTranslationPreferenceRequestFromJSONTyped(json, false);
}

export function UpdateSearchTranslationPreferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSearchTranslationPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'preference': json['preference'],
    };
}

export function UpdateSearchTranslationPreferenceRequestToJSON(value?: UpdateSearchTranslationPreferenceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'preference': value['preference'],
    };
}

